import { h, Component } from "preact";
import { useCallback, useRef } from "preact/hooks";
import $ from "jquery";
import GlobState from 'globstate'
import Globals from '../globals.js'
import * as _ from "../components/index.js";
import QuickPinchZoom, { make3dTransformValue } from "react-quick-pinch-zoom";
class Test extends Component {

  constructor(props) {
    super(props);
    let templateId = parseInt(props.id);
    let templates = Globals.Templates();
    let template = templates[templateId - 1];
    let myFavs = JSON.parse(localStorage.getItem('favs_' + templateId))
    let answers = JSON.parse(localStorage.getItem('answers_' + templateId));
    let usedExp = JSON.parse(localStorage.getItem('exp_' + templateId));

    this.state = {
      questionsTotal: template.questions ? Object.keys(template.questions).length : 0,
      template: template,
      questions: template.questions ? template.questions : {},
      answers: answers,
      usedExp: usedExp,
      favs: myFavs,
      activeQuestion: 0,
      lang: props.app.lang,
      templateId: templateId,
      scrollLeftPosition: 0,
      imgRef: false
    };

    this.setState({
      activeQuestion: this.findFirstQuestion()
    })

  }

  findFirstQuestion() {
    let questions = this.state.questions;
    let questionNum = 0;
    let finded = false;

    {
      Object.keys(questions).map((tmp) => {
        if (!finded) {
          let question = questions[tmp];
          if (this.state.answers && !this.state.answers[question.id]) {
            if (this.state.usedExp && !this.state.usedExp[question.id]) {
              questionNum = tmp;
              finded = true;
            }
          }
        }
      })
    }
    return questionNum;
  }

  componentDidMount() {

  }

  hideExp = (e) => {
    $('.questionExp').addClass('d-none');
  }

  showExp = (e) => {
    $('.questionExp').removeClass('d-none');

    let expData = localStorage.getItem('exp_' + this.state.templateId) ? localStorage.getItem('exp_' + this.state.templateId) : '{}';
    let exp = JSON.parse(expData);

    let t = $(e.target).closest('.idea');
    let questionId = parseInt(t.attr('rel'));
    if (!exp) {
      exp = {}
    }
    exp[questionId] = 1;

    this.setState({
      usedExp: exp
    })

    this.scrollTo('.answersDiv');

    localStorage.setItem('exp_' + this.state.templateId, JSON.stringify(exp));
  }

  setActiveQuestion = (e) => {
    let rel = parseInt($(e.target).attr('rel'));
    this.setState({
      activeQuestion: rel
    })
    this.centerActiveItem(rel);
  }

  setAnswer = (e) => {

    let answersData = localStorage.getItem('answers_' + this.state.templateId) ? localStorage.getItem('answers_' + this.state.templateId) : '{}';
    let answers = JSON.parse(answersData ? answersData : '{}');

    let expData = localStorage.getItem('exp_' + this.state.templateId) ? localStorage.getItem('exp_' + this.state.templateId) : '{}';
    let exp = JSON.parse(expData);

    let t = $(e.target);
    let questionId = parseInt(t.attr('rel'));
    let answerId = parseInt(t.val());

    if (!answers) {
      answers = {}
    }

    if (!exp) {
      exp = {}
    }

    let isAnswered = answers[questionId] || exp[questionId] ? true : false;

    if (isAnswered) {
      e.preventDefault();
      return false;
    }

    answers[questionId] = answerId;

    if (exp) {
      if (exp[questionId]) {
        delete exp[questionId];
        this.setState({
          usedExp: exp
        })
      }
    }

    localStorage.setItem('exp_' + this.state.templateId, JSON.stringify(exp));

    let isCorrect = false;
    let idx = this.state.questions.findIndex(x => x.id == questionId);
    let idxA = this.state.questions[idx].answers.findIndex(x => x.id == answerId);

    if (this.state.questions[idx].answers[idxA].isCorrect) {
      isCorrect = true;
    }

    this.setState({
      answers: answers,
      isCorrect: isCorrect,
    })

    if (isCorrect && this.state.activeQuestion != 9) {
      // setTimeout(this.nextQuestion, 2000);
      this.nextQuestion();
    } else {
      this.scrollTo('.answersDiv');
    }

    localStorage.setItem('answers_' + this.state.templateId, JSON.stringify(answers));
  }

  nextQuestion = () => {
    let nextQuestion = parseInt(this.state.activeQuestion) + 1;
    if (nextQuestion > 9) {
      nextQuestion = 9;
    }
    if (this.state.activeQuestion == 9) {
      nextQuestion = this.findFirstQuestion();
    }
    this.setState({
      activeQuestion: nextQuestion
    })
    this.centerActiveItem(nextQuestion);
    window.scrollTo({ top: 0 });
  }

  scrollTo(selector) {
    window.scroll(0, this.findPosition(document.querySelector(selector)));
  }

  findPosition(obj) {
    var currenttop = 0;
    if (obj.offsetParent) {
      do {
        currenttop += obj.offsetTop;
      } while ((obj = obj.offsetParent));
      return [currenttop];
    }
  }

  centerActiveItem = (act) => {
    if (typeof act == 'undefined') {
      act = this.state.activeQuestion;
    }
    let scrollPosition = (act - 3) * 37
    this.setState((state) => {
      return {
        ...state,
        scrollLeftPosition: scrollPosition
      };
    });
    console.log('test')
    $('.quest_img').attr("style", "transform: none");
  }

  showErrorModal = () => {

  }

  complete = () => {

  }

  addFav = (e) => {
    let data = JSON.parse(localStorage.getItem('favs_' + this.state.templateId))

    let t = $(e.target);
    let questionId = parseInt(t.attr('rel'));

    if (!data) {
      data = {}
    }
    data[questionId] = 1

    this.setState({
      favs: data
    })

    localStorage.setItem('favs_' + this.state.templateId, JSON.stringify(data));
    $('#add_favorite_item').parent().find('.btn-secondary').click();
  }

  delFav = (e) => {
    let data = JSON.parse(localStorage.getItem('favs_' + this.state.templateId))
    let t = $(e.target);
    let questionId = parseInt(t.attr('rel'));
    if (data) {
      if (data[questionId]) {
        delete data[questionId];
        this.setState({
          favs: data
        })
      }
    }
    localStorage.setItem('favs_' + this.state.templateId, JSON.stringify(data));
    $('#del_favorite_item').parent().find('.btn-secondary').click();
  }

  render() {
    let imgRef = useRef();
    let onUpdate = useCallback(({ x, y, scale }) => {
      const { current: img } = imgRef;

      if (img) {
        const value = make3dTransformValue({ x, y, scale });
        img.style.setProperty("transform", value);
      }
    }, []);

    let lang = this.state.lang
    let template = this.state.template;
    let questions = this.state.questions ? this.state.questions : {};
    let favs = this.state.favs ? this.state.favs : {};
    let questionsTotal = this.state.questionsTotal;

    let activeQuestion = this.state.activeQuestion;

    let data = this.state.questions ? this.state.questions[activeQuestion] : {};
    let image = data ? data.image : null;
    let answers = data ? data.answers : null;

    let qClass = '';
    let correctAnswer = '';
    let displayExp = 'd-none';
    let displayExpIcon = '';
    let ansLength = this.state.answers ? Object.keys(this.state.answers).length : 0
    let exp = this.state.usedExp ? this.state.usedExp : {}
    let expLength = this.state.usedExp ? Object.keys(this.state.usedExp).length : 0

    let displayNextQuestion = (ansLength + expLength != questionsTotal ? '' : 'd-none');
    let displayComplete = (ansLength + expLength == questionsTotal ? '' : 'd-none');

    let isFav = favs[data.id] ? true : false;

    let counters = {
      correct: 0,
      exp: 0,
    }
    return (
      <>

        <section class="header">

          <div class="header_menu">
            <div class="d-flex align-items-center">
              <a href={ansLength > 0 ? "#" : '/templates/'} class="mx-2" type="button" data-bs-toggle={ansLength > 0 ? "modal" : false} data-bs-target="#back"><i class="demo-icon icon-angle-left"></i></a>
              <span class="ms-2">Билет {template.title}</span>
            </div>
            <div class="d-flex align-items-center">
              {/* <span class="time"><i class="demo-icon icon-clock-1 me-1"></i>15:00</span> */}
              {!isFav ?
                <a href="#" class="mx-2" type="button" data-bs-toggle="modal" data-bs-target="#add_favorite_item">
                  <i class="demo-icon icon-heart-empty-1 red_icon"></i>
                </a>
                :
                <a href="#" class="mx-2" data-bs-toggle="modal" data-bs-target="#del_favorite_item">
                  <i class="demo-icon icon-heart-1 red_icon"></i>
                </a>
              }

            </div>
          </div>

          <div class="options" ref={(ref) => (this.scrollRef = ref)}>
            {Object.keys(questions).map((tmp) => {
              { qClass = '' }

              {
                if (exp[questions[tmp].id]) {
                  qClass = 'option_orange';
                } else {
                  if (this.state.answers && this.state.answers[questions[tmp].id]) {
                    if (questions[tmp].correctId == this.state.answers[questions[tmp].id]) {
                      counters.correct++;
                      qClass = 'option_green';
                    } else {
                      qClass = 'option_red';
                    }
                  }
                }

                if (activeQuestion == tmp) {
                  qClass += ' option_active';
                }
              }

              return <a href="javascript:void(0)" ref={(ref) => {
                if (activeQuestion == tmp) {
                  this.activeRef = ref;
                }
              }} onClick={this.setActiveQuestion} rel={tmp} class={`option ${qClass}`}>{questions[tmp].ord}</a>
            })}
          </div>

        </section>

        <section class="menu menu_test">

          <div class="quest">

            {(image ? <QuickPinchZoom onUpdate={onUpdate}>
              {/* <img ref={imgRef} src={IMG_URL} /> */}
              <img src={image} href={image} ref={imgRef} alt="" class="quest_img" data-gallery="manual" />
            </QuickPinchZoom> : null)}
            <span class="font_bold">Вопрос:</span>
            <span class="" dangerouslySetInnerHTML={{
              __html: data.question[lang]
            }}></span>
          </div>

          <div class="my-2 answersDiv">
            {Object.keys(answers).map((tmp) => {
              var isChecked = false;
              var isCorrect = false;
              var className = 'false';

              if (answers[tmp]['isCorrect']) {
                correctAnswer = answers[tmp][lang]
                exp = answers[tmp]['exp'][lang]
                isCorrect = true;
                className = 'true';
              } else {
                // className = 'false';
              }

              if (this.state.answers && this.state.answers[data.id]) {

                if (isCorrect && this.state.answers[data.id] != answers[tmp]['id']) {
                  className = 'bg-success';
                } else {
                  displayExp = '';
                  displayExpIcon = 'd-none';
                }
              }

              if (this.state.answers && this.state.answers[data.id] == answers[tmp]['id']) {
                isChecked = true;
              } else {
                if (isCorrect) {
                  if (this.state.usedExp && this.state.usedExp[data.id]) {
                    // isChecked = true;
                    className = 'bg-success';
                    displayExp = '';
                    displayExpIcon = 'd-none';
                  }
                }
              }

              return <span>
                <input type="radio" class={className} id={`answer_${answers[tmp]['id']}`} rel={data.id} name={`answer`} value={answers[tmp]['id']} data-isCorrect={answers[tmp]['isCorrect']} onClick={this.setAnswer} checked={isChecked} />
                <label for={`answer_${answers[tmp]['id']}`} dangerouslySetInnerHTML={{
                  __html: answers[tmp][lang]
                }}></label>
              </span>
            })}
          </div>

          <div class={`d-flex flex-column questionExp ${displayExp}`}>
            <span class="font_bold">Правильный ответ:</span>
            <span class="mt-1">{correctAnswer}</span>

            <a class={`btn btn-info mt-3 ${displayNextQuestion}`} href="javascript:void(0)" onClick={this.nextQuestion} role="button">Следующий вопрос</a>
            <a class={`btn btn-info mt-3 ${displayComplete}`} href="javascript:void(0)" onClick={this.complete} data-bs-toggle="modal" data-bs-target="#finish">Готово</a>

            <span class="font_bold mt-3">Комментарий:</span>
            <span class="mt-1" dangerouslySetInnerHTML={{
              __html: exp
            }}></span>

            <a class="btn btn-light mt-3" onClick={this.showErrorModal} href="javascript:void(0)" role="button">Сообщить об ошибке</a>
          </div>

          <a href="javascript:void(0)" onClick={this.showExp} rel={data.id} class={`idea ${displayExpIcon}`}><i class="demo-icon icon-lightbulb-1"></i></a>
        </section>

        <div class="modal fade" id="add_favorite_item" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20">Добавить в избранное?</span>
                  <div>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                    <button type="button" class="btn btn-success mx-3" rel={data.id} onClick={this.addFav}>Добавить</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="del_favorite_item" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20">Удалить вопрос из избранного?</span>
                  <div>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                    <button type="button" class="btn btn-danger mx-3" rel={data.id} onClick={this.delFav}>Удалить</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="back" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20">Хотите выйти?</span>
                  <div>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                    <a href="/templates/" class="btn btn-danger ms-3" data-bs-dismiss="modal">Выход</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="finish" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20">Результат:</span>
                  <span class="mb-1">Правильный <span class="text-success">{counters.correct}</span> \ {questionsTotal}</span>
                  <span class="mb-1">Неправильный <span class="text-danger">{questionsTotal - (counters.correct + expLength)}</span> \ {questionsTotal}</span>
                  {expLength > 0 ? <div class="mb-1">Подсказки <span class="text-warning">{expLength}</span></div> : null}
                  <div class="mt-3">
                    <button type="button" class="btn btn-primary">Начать сначала</button>
                    <button type="button" class="btn btn-success mx-2" data-bs-dismiss="modal">ОК</button>
                    <a href="/templates/" type="button" class="btn btn-info mx-2" data-bs-dismiss="modal">Назад</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </>
    );
  }
}

export default GlobState.connect(Test, Globals)